import Marquee from "react-fast-marquee";
import { useReducedMotion } from "framer-motion";

const WORDS = [
  "STOP THE SCROLL",
  "TURN VIEWERS INTO BUYERS",
  "DTC + B2B SAAS",
  "NO FILMING",
  "NO STUDIOS",
  "FREE 24H SAMPLE",
  "MOTION ADS",
];

export const MarqueeStrip = () => {
  const reduce = useReducedMotion();
  return (
    <div className="border-y border-zinc-900 bg-black py-5" data-testid="marquee-strip">
      <Marquee autoFill play={!reduce} speed={45} gradient={false}>
        {WORDS.map((w, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="font-display text-2xl font-bold uppercase tracking-tight text-zinc-200 sm:text-3xl">
              {w}
            </span>
            <span className="text-[#C7FF3C]">✳</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
